import { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Theme } from '../../styles/settings/theme'
import { Flex, Text, Box } from 'rebass'
import { FaBars } from 'react-icons/fa'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { DataContext } from '../../contexts/dataContext'
import { lang } from '../../utils/lang'
import Logo from '../../assets/boroumand_logo.svg'
import { BASE_URL } from '../../utils/constants'

const StyledBar = styled(Flex)`
  height: 4.5rem;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 40;
  width: 100%;
  background-image: linear-gradient(to bottom, #ffffff, #dedede);
  font-family: Arial;
  font-weight: 700;
  ${Mq.xs} {
    //position: relative;
  }
  ${Mq.sm} {
    height: 3rem;
  }
`

const Name = styled(Text)`
  font-size: 1rem;
  line-height: 1.15;
  color: ${(props) => props.theme.colors.black};
  a {
    color: ${(props) => props.theme.colors.black};
    text-decoration: none;
    &:hover {
      color: ${(props) => props.theme.colors.red};
      text-decoration: none;
    }
  }
  ${Mq.sm} {
    font-size: 1rem;
  }
  span {
    font-size: 0.85rem;
    color: ${(props) => props.theme.colors.darkRed};
    &:hover {
      color: ${(props) => props.theme.colors.red};
      text-decoration: none;
    }
    ${Mq.sm} {
      font-size: 1rem;
    }
  }
`
const Menu = styled.ul`
  display: none;
  ${Mq.md} {
    display: flex;
    font-size: 0.8rem;
    justify-content: space-evenly;
    flex: 1;
    li {
      color: ${(props) => props.theme.colors.darkRed};
      text-decoration: none;
      cursor: pointer;
      a {
        color: ${(props) => props.theme.colors.darkRed};
        &:hover {
          color: ${(props) => props.theme.colors.red};
          text-decoration: none;
        }
      }
    }
  }
`
const StyledFlex = styled(Flex)`
  flex-direction: column;
  ${Mq.sm} {
    flex-direction: row;
  }
`
const StyledText = styled(Text)`
  ${Mq.sm} {
    padding-left: 0.3rem;
  }
`
const MobileBox = styled(Box)`
  display: block;
  padding: ${(props) => (props.ui === 'en' ? '0 1rem 0 0' : '0 0 0 1rem')};
  cursor: pointer;
  ${Mq.md} {
    display: none;
  }
`
const NavBar = ({ handleMobileOpen }) => {
  //when sending build files, uncomment the first useContext and comment out the second one.
  const { ui, setSelections, intro } = useContext(DataContext)
  //const { ui, setUi, setSelections } = useContext(DataContext)

  const dir = ui === 'en' ? 'ltr' : 'rtl'

  const changeLang = () => {
    //when sending build files, comment out next two lines
    //if (ui === 'en') setUi('fa')
    //else if (ui === 'fa') setUi('en')
    setSelections({
      Religion: 'ALL',
      Occupation: 'ALL',
      Education: 'ALL',
      Gender: 'ALL',
      'Threats or failed attempts': 'ALL',
      'Modes of killing': 'ALL',
      Arrests: 'ALL',
      Prosecution: 'ALL'
    })
  }
  // console.log('intro', intro)
  const uiLang = ui === 'fa' ? 'fa/' : ''

  return (
    <StyledBar dir={dir}>
      <Flex alignItems="center">
        <Box p={ui === 'en' ? '.5rem 0 0 1rem' : '.5rem 1rem 0 0'}>
          <img src={Logo} alt={lang[ui]['Logo']} />
        </Box>
        <Name ml={ui === 'en' ? 2 : 0} mr={ui === 'en' ? 0 : '12px'}>
          <a href={`${BASE_URL}/${uiLang}`} target="_blank" rel="noreferrer">
            <StyledFlex>
              <StyledText>{lang[ui]['Abdorrahman']}</StyledText>
              <StyledText>{lang[ui]['Boroumand']}</StyledText>
              <StyledText>
                <span>{lang[ui]['HumanRights']}</span>
              </StyledText>
            </StyledFlex>
          </a>
        </Name>
      </Flex>
      <Menu>
        <li onClick={changeLang}>
          {/* when sending build files, uncomment these lines with real FA/EN URL */}
          <a
            href={
              ui === 'en'
                ? `${BASE_URL}/projects/EJK/fa?intro=${intro}`
                : `${BASE_URL}/projects/EJK/en?intro=${intro}`
            }
            //target="_blank"
            rel="noreferrer"
          >
            {ui === 'en' ? 'فارسی' : 'English'}
          </a>

          {/* when sending build files, comment this out:  */}
          {/* {ui === 'en' ? 'فارسی' : 'English'} */}
        </li>
        <li>
          <a
            href={`${BASE_URL}/${uiLang}memorial`}
            target="_blank"
            rel="noreferrer"
          >
            {lang[ui]['Memorial']}
          </a>
        </li>
        <li>
          <a
            href={`${BASE_URL}/${uiLang}library`}
            target="_blank"
            rel="noreferrer"
          >
            {lang[ui]['Library']}
          </a>
        </li>
        <li>
          <a href={`${BASE_URL}/${uiLang}`} target="_blank" rel="noreferrer">
            {lang[ui]['Projects']}
          </a>
        </li>
        <li>
          <a
            href={`${BASE_URL}/${uiLang}center`}
            target="_blank"
            rel="noreferrer"
          >
            {lang[ui]['About']}
          </a>
        </li>
        <li>
          <a
            href={`${BASE_URL}/${uiLang}newsletter`}
            target="_blank"
            rel="noreferrer"
          >
            {lang[ui]['News']}
          </a>
        </li>
      </Menu>
      <MobileBox ui={ui}>
        <FaBars color={Theme.colors.black} onClick={handleMobileOpen} />
      </MobileBox>
    </StyledBar>
  )
}

export default NavBar

NavBar.propTypes = {
  handleMobileOpen: PropTypes.func.isRequired
}
